import AuthService from 'src/services/auth.service';

export default class VideoService {

  static extractVideoProperties(asset) {
    switch (asset.metadata.external_video_provider) {
      case 'youtube':
        return this.extractExternalVideoProperties(asset);
      default:
        return this.extractDefaultVideoProperties(asset);
    }
  }

  static extractExternalVideoProperties(asset) {
    var videoDetail = {
      src: asset.metadata.url,
      type: asset.metadata.external_video_type
    }

    return videoDetail;
  }

  static extractDefaultVideoProperties(asset) {
    var videoDetail = {
      src: AuthService.getURL(`api/2.0/assets/${asset.id}/download`, {preview: true}),
      type: asset.metadata.content_type
    }
    return videoDetail;
  }

}